import {IBaseFetchOptions, IBaseParameters, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	GET_ACTIVITIES: {
		path: 'activities',
		method: 'GET'
	},
	GET_PROFILE: {
		path: 'profile',
		method: 'GET'
	},
	GET_WALLET: {
		path: 'customer-wallet',
		method: 'GET'
	},
	JOIN_LOYALTY: {
		path: 'join',
		method: 'POST'
	}
};

interface ILoyaltyFetchOptions extends IBaseFetchOptions {
	parameters?: IBaseParameters & {
		c_email: string
	}
}

interface ITier {
	id: string;
	name: string;
	tierType: string;
	points: number;
	purchases: number;
	icon: string;
	fullIconPath: string;
	allowDropout: boolean;
	entryAt?: number;
	hasExpirationDate?: boolean;
	expireAt?: number;
	hidden: boolean
}

interface IPointsAllocation {
	amount: number;
	pointsType: string;
	allocatedAt: number
}

export type IGetLoyaltyActivitiesOptions = ILoyaltyFetchOptions;

export type IGetLoyaltyProfileOptions = ILoyaltyFetchOptions;

export type IGetLoyaltyWalletOptions = ILoyaltyFetchOptions;

export interface IJoinToLoyaltyOptions {
	body?: {
		email: string
	}
}

export interface IGetLoyaltyActivitiesResponse extends IBaseResponse {
	loyaltyActivities: Array<{
		time: string,
		points: number,
		status: string,
		orderNo: string,
		type: string
	}>;
}

export interface IGetLoyaltyProfileResponse extends IBaseResponse {
	loyaltyProfile: {
		id: string;
		planId: string;
		currentTier: ITier;
		nextTier: ITier;
		points: {
			name: string;
			nameSingular: string;
			balance: number;
			pending: number;
			status: number;
			expiresSoon: number;
			cashback: number;
			cashbackPending: number;
			pointsAllocations: Array<IPointsAllocation>;
		};
		joinDate: string;
		hasJoinedProgram: boolean;
		isActive: boolean;
		purchases: number;
		isTierCalcTier: boolean;
		availablePoints: number;
		colorTier: string;
		currentTierName: string;
		nextTierName: string;
		nextTierPoints: boolean;
	};
}

export interface IGetLoyaltyWalletResponse extends IBaseResponse {
	loyaltyWallet: {
		appId: string;
		customerEmail: string;
		customerId: string;
		planId: string;
		timestamp: number;
		token: string;
		region: string;
		language: string;
		currency: string;
		country: string;
	}
}

export interface IJoinToLoyaltyResponse extends IBaseResponse {
	status: string
}
